import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';
import ThemeToggle from './ThemeToggle';
import '../styles/global.css';

const Navbar: React.FC = () => {
  const { user, logout, isAuthenticated } = useAuth();
  const { isDark } = useTheme();
  const location = useLocation();
  const [activePath, setActivePath] = useState(location.pathname);

  useEffect(() => {
    setActivePath(location.pathname);
    // Сохраняем активный путь в localStorage
    localStorage.setItem('activeNavPath', location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    // Восстанавливаем активный путь из localStorage при монтировании
    const savedPath = localStorage.getItem('activeNavPath');
    if (savedPath) {
      setActivePath(savedPath);
    }
  }, []);

  const isActive = (path: string) => {
    return activePath === path;
  };

  return (
    <nav className="navbar">
      <div className="navbar-content">
        <Link to="/" className="navbar-brand">
          <img
            src={isDark ? "/logo_voxlink_white.svg" : "/logo_voxlink.svg"}
            alt="Career Growth"
            style={{ height: '40px', width: 'auto' }}
          />
        </Link>

        <ul className="navbar-nav">
          {isAuthenticated ? (
            <>
              {/* Гость видит только ссылку на public dashboard */}
              {user?.role === 'guest' ? (
                <li>
                  <Link
                    to="/public"
                    className={`nav-link ${isActive('/public') ? 'active' : ''}`}
                  >
                    Публичный дашборд
                  </Link>
                </li>
              ) : (
                <>
                  {/* Инженер и выше видят главную */}
                  <li>
                    <Link
                      to="/dashboard"
                      className={`nav-link ${isActive('/dashboard') ? 'active' : ''}`}
                    >
                      Главная
                    </Link>
                  </li>

                  {/* Админ видит панель администратора */}
                  {user?.role === 'admin' && (
                    <>
                      <li className="nav-dropdown">
                        <span className={`nav-link ${isActive('/admin/achievements') || isActive('/admin/tasks') || isActive('/admin/notifications') ? 'active' : ''}`}>
                          Создание <span className="dropdown-arrow">→</span>
                        </span>
                        <ul className="nav-dropdown-menu">
                          <li>
                            <Link
                              to="/admin/users"
                              className={`nav-link ${isActive('/admin/users') ? 'active' : ''}`}
                            >
                              Пользователи
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/pya3"
                              className={`nav-link ${isActive('/pya3') ? 'active' : ''}`}
                            >
                              Транскрипция аудио
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/admin/achievements"
                              className={`nav-link ${isActive('/admin/achievements') ? 'active' : ''}`}
                            >
                              Достижения
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/admin/positions"
                              className={`nav-link ${isActive('/admin/positions') ? 'active' : ''}`}
                            >
                              Должности
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/admin/tasks"
                              className={`nav-link ${isActive('/admin/tasks') ? 'active' : ''}`}
                            >
                              Задания
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/admin/notifications"
                              className={`nav-link ${isActive('/admin/notifications') ? 'active' : ''}`}
                            >
                              Уведомления
                            </Link>
                          </li>
                        </ul>
                      </li>
                    </>
                  )}

                  {/* Руководитель инженеров и админ видят проверку заданий */}
                  {(user?.role === 'engineering_manager' || user?.role === 'admin') && (
                    <li>
                      <Link
                        to="/admin/tasks-check"
                        className={`nav-link ${isActive('/admin/tasks-check') ? 'active' : ''}`}
                      >
                        Проверка заданий
                      </Link>
                    </li>
                  )}

                  {/* Инженер и выше видят профиль и прогресс */}
                  <li>
                    <Link
                      to="/profile"
                      className={`nav-link ${isActive('/profile') ? 'active' : ''}`}
                    >
                      Профиль
                    </Link>
                  </li>
                  <li className="nav-dropdown">
                    <span className={`nav-link ${isActive('/achievements') || isActive('/tasks') ? 'active' : ''}`}>
                      Мой прогресс <span className="dropdown-arrow">→</span>
                    </span>
                    <ul className="nav-dropdown-menu">
                      <li>
                        <Link
                          to="/achievements"
                          className={`nav-link ${isActive('/achievements') ? 'active' : ''}`}
                        >
                          Достижения
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/tasks"
                          className={`nav-link ${isActive('/tasks') ? 'active' : ''}`}
                        >
                          Задания
                        </Link>
                      </li>
                    </ul>
                  </li>
                </>
              )}
              <li>
                <button onClick={logout} className="btn btn-outline">
                  Выйти
                </button>
              </li>
            </>
          ) : (
            <li>
              <Link
                to="/login"
                className={`nav-link ${isActive('/login') ? 'active' : ''}`}
              >
                Войти
              </Link>
            </li>
          )}
          <li>
            <ThemeToggle />
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
